/**
 * This exception is thrown when a request is made with equipment serial that’s already in the database.
 */
export class DuplicateEquipmentSerialException extends Error {}

/**
 * This exception is thrown when an invalid serial is sent to the api when adding a equipment.
 */
export class SerialValidationException extends Error {}

/**
 * This exception is thrown when a request is made with the id of a equipment that does not exist in the database.
 */
export class EquipmentNotFoundException extends Error {}

/**
 * This exceptions is thrown when a business tries to register a product that
 * belongs to an equipment series different than the series of the equipments
 * he already has registered
 */
export class EquipmentSeriesIncompatibleWithTheBusinessException extends Error {}

/**
 * Exception thrown when a file with the same name has already been uploaded
 */
export class DuplicateFileNameException extends Error {}
